/**
 * Per `character-life-simulation` capability — character internal
 * parallel-world state. One row per fanMode-enabled character, updated
 * every 6 hours by the life-tick Lambda (and on operator manual
 * trigger). Stored in `nx-character-life-<env>` with PK=`characterId`.
 *
 * The state feeds into chat.ts's system prompt so every conversation
 * is coloured by "what the character is doing right now". Time inside
 * the simulated world is 1:1 with real time — no compression.
 */
import { z } from 'zod';
export const LifeEventSchema = z.object({
    /** ISO datetime the event was generated (real-world time). */
    ts: z.string().datetime(),
    /** Short narrative — 5-100 characters, Chinese. */
    text: z.string().min(5).max(100),
});
export const LifeStateRowSchema = z.object({
    characterId: z.string().min(1),
    /** Short Chinese phrase, e.g., "輕鬆愉快" / "若有所思" / "煩躁". */
    mood: z.string().min(1).max(20),
    /** Single-line description of what the character is doing now. */
    currentScene: z.string().min(1).max(120),
    /** Chronological log of recent events, newest first, capped at 10. */
    recentEvents: z.array(LifeEventSchema).max(10),
    /** ISO datetime of the most recent tick (manual or scheduled). */
    updatedAt: z.string().datetime(),
    /** DEPRECATED — life-tick is no longer on a platform schedule. The
     *  field is kept readable for migration tolerance but new rows do
     *  NOT set it, and the dashboard does not display a countdown.
     *  Operator-configured workflows or manual `/tick-now` are the only
     *  triggers. */
    nextTickAt: z.string().datetime().optional(),
    /** ISO datetime stamping rate-limit on manual-tick. When set + still
     *  in the future, /tick-now is rejected with 429. */
    manualTickLockUntil: z.string().datetime().optional(),
});
